import React, { useState } from "react";
import PropTypes from "prop-types";

import ChevronRight from "../../shared/Icons/ChevronRight";
import TaskRow from "./TaskRow";
import { taskState } from "../checklistFilters";

const ChecklistGroup = ({ group }) => {
  const [expanded, setExpanded] = useState(!(group.total > 0 && group.complete >= group.total));
  const overdueCount = group.tasks.filter((task) => taskState(task) === "overdue").length;

  return (
    <div>
      <button
        type="button"
        className="onboarding-group-header"
        aria-expanded={expanded}
        onClick={() => setExpanded(!expanded)}
      >
        <span className={`onboarding-group-chevron ${expanded ? "onboarding-group-chevron-open" : ""}`}>
          <ChevronRight fill="var(--sl-fg-quinary)" width="14" height="14" />
        </span>
        <span className="onboarding-group-name">{group.name}</span>
        <span className="onboarding-group-count">{group.complete} of {group.total} complete</span>
        {overdueCount > 0 && (
          <span className="onboarding-group-overdue">{overdueCount} overdue</span>
        )}
      </button>
      {expanded && group.tasks.map((task) => <TaskRow key={task.id} task={task} />)}
    </div>
  );
};

ChecklistGroup.propTypes = {
  group: PropTypes.shape({
    name: PropTypes.string.isRequired,
    total: PropTypes.number.isRequired,
    complete: PropTypes.number.isRequired,
    tasks: PropTypes.array.isRequired,
  }).isRequired,
};

export default ChecklistGroup;
